// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICensusRequestAcceptedDto,
  ICensusRequestBatchDto,
  ICensusResultDto,
  IErrorDto,
  IGenericErrorDto,
} from '../models/index';
import {
    ICensusRequestAcceptedDtoFromJSON,
    ICensusRequestAcceptedDtoToJSON,
    ICensusRequestBatchDtoFromJSON,
    ICensusRequestBatchDtoToJSON,
    ICensusResultDtoFromJSON,
    ICensusResultDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
} from '../models/index';

export interface GetCensusResultRequest {
    requestId: number;
}

export interface ProcessCensusRequest {
    oRGID: string;
    iCensusRequestBatchDto: ICensusRequestBatchDto;
}

/**
 * CensusServiceServiceApi - interface
 * 
 * @export
 * @interface CensusServiceServiceApiInterface
 */
export interface CensusServiceServiceApiInterface {
    /**
     * Retrieve the processing results for a specific census request by ID
     * @summary Get census processing result
     * @param {number} requestId Census request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CensusServiceServiceApiInterface
     */
    getCensusResultRaw(requestParameters: GetCensusResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICensusResultDto>>;

    /**
     * Retrieve the processing results for a specific census request by ID
     * Get census processing result
     */
    getCensusResult(requestParameters: GetCensusResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICensusResultDto>;

    /**
     * Submit a batch of census records for processing. Supports multiple ID source types (SSN, PID, EID).
     * @summary Process census batch
     * @param {string} oRGID Organization ID for partner-specific processing
     * @param {ICensusRequestBatchDto} iCensusRequestBatchDto Census batch data with records to process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CensusServiceServiceApiInterface
     */
    processCensusRaw(requestParameters: ProcessCensusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICensusRequestAcceptedDto>>;

    /**
     * Submit a batch of census records for processing. Supports multiple ID source types (SSN, PID, EID).
     * Process census batch
     */
    processCensus(requestParameters: ProcessCensusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICensusRequestAcceptedDto>;

}

/**
 * 
 */
export class CensusServiceServiceApi extends runtime.BaseAPI implements CensusServiceServiceApiInterface {

    /**
     * Retrieve the processing results for a specific census request by ID
     * Get census processing result
     */
    async getCensusResultRaw(requestParameters: GetCensusResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICensusResultDto>> {
        if (requestParameters['requestId'] == null) {
            throw new runtime.RequiredError(
                'requestId',
                'Required parameter "requestId" was null or undefined when calling getCensusResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/census/{requestId}`;
        urlPath = urlPath.replace(`{${"requestId"}}`, encodeURIComponent(String(requestParameters['requestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICensusResultDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve the processing results for a specific census request by ID
     * Get census processing result
     */
    async getCensusResult(requestParameters: GetCensusResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICensusResultDto> {
        const response = await this.getCensusResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit a batch of census records for processing. Supports multiple ID source types (SSN, PID, EID).
     * Process census batch
     */
    async processCensusRaw(requestParameters: ProcessCensusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICensusRequestAcceptedDto>> {
        if (requestParameters['oRGID'] == null) {
            throw new runtime.RequiredError(
                'oRGID',
                'Required parameter "oRGID" was null or undefined when calling processCensus().'
            );
        }

        if (requestParameters['iCensusRequestBatchDto'] == null) {
            throw new runtime.RequiredError(
                'iCensusRequestBatchDto',
                'Required parameter "iCensusRequestBatchDto" was null or undefined when calling processCensus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['oRGID'] != null) {
            headerParameters['ORG-ID'] = String(requestParameters['oRGID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/census`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICensusRequestBatchDtoToJSON(requestParameters['iCensusRequestBatchDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICensusRequestAcceptedDtoFromJSON(jsonValue));
    }

    /**
     * Submit a batch of census records for processing. Supports multiple ID source types (SSN, PID, EID).
     * Process census batch
     */
    async processCensus(requestParameters: ProcessCensusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICensusRequestAcceptedDto> {
        const response = await this.processCensusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
